<template>
  <div class="layout_wraper">
    <div class="layout_left">
      <MainTitle val="Traffic operation situation" />
      <div class="operation">
        <div class="operationIndex">
          <SecTitle
            style="cursor: pointer;"
            val="Traffic operation index"
            @click.native="disRoad"
          />
          <div class="operationIndex_Info">
            <div class="left">
              <YibiaopanTu
                :styleChart="{
                  width: '270px',
                  height: '140px'
                }"
                :dataRatio="60"
              />
            </div>
            <div class="right">
              <div class="name">Traffic jam</div>
              <div class="value">98</div>
              <div class="unit">Fra</div>
            </div>
          </div>
        </div>
        <div class="ranking">
          <SecTitle val="Regional congestion ranking" />
          <div class="ranking_info">
            <div
              class="right_item"
              v-for="(item, index) in rankingList"
              :key="index"
            >
              <!-- <img
                    class="img"
                    src="../../assets/img/LeftView/ChangJingShiTu/yjjr_bg.png"
                  /> -->
              <div class="item">
                <div class="item_index" :class="'item_index' + index">
                  {{ '0' + (index + 1) }}
                </div>
                <div class="name">{{ item.text }}</div>
                <div class="jindu">
                  <div
                    :style="{
                      width: item.per + '%',
                      background: `repeating-linear-gradient(to right,${yjColor[index]},${yjBg[index]})`
                    }"
                  ></div>
                </div>
                <div class="value">{{ item.num }}</div>
                <div
                  class="unit"
                  :style="{
                    color: `${yjBg[index]}`
                  }"
                >
                  {{ item.unit }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <MainTitle val="Transport service resources">
        <div class="btnSelect">
          <div
            @click="TransportBtn('Day')"
            :class="TransportType == 'Day' ? 'select' : ''"
          >
            Day
          </div>
          <div
            @click="TransportBtn('Week')"
            :class="TransportType == 'Week' ? 'select' : ''"
          >
            Week
          </div>
          <div
            @click="TransportBtn('Month')"
            :class="TransportType == 'Month' ? 'select' : ''"
          >
            Month
          </div>
        </div>
      </MainTitle>
      <div class="Transport">
        <ChartPie
          class="chart_pie"
          width="300px"
          height="300px"
          :rowData="TransportList"
          :displayModel="displayModel"
          :color="['#A68CDB', '#17CAA6', '#73FFFF', '#56A2E7']"
          :legends="{
            Bus: '#A68CDB',
            Taxi: '#17CAA6',
            'Rail transit': '#73FFFF',
            'Water bus': '#56A2E7'
          }"
          :loop_labelStyle="{
            left: '400%',
            top: '21%'
          }"
          :legendsStyle="{
            right: '-66px',
            unitright: '-90px'
          }"
        />
        <Table
          style="margin:10px 0"
          :NavData="['Total', 'How many', 'Run Today']"
          :TableStyle="{
            TableWidth: '680px',
            Height: '270px',
            NavlineHeight: '50px'
          }"
          :TableCountWidth="['150px', '230px', '300px']"
          :Data="ViolationsList2"
        />
      </div>
      <MainTitle val="Traffic facilities statistics" />
      <div class="Traffic">
        <div class="li" v-for="(item, index) in Traffic" :key="index">
          <div class="name">{{ item.name }}</div>
          <div class="info">
            <div class="value">{{ item.value }}</div>
            <!-- <div class="unit">Ind</div> -->
          </div>
        </div>
      </div>
    </div>
    <div class="layout_center"></div>
    <div class="layout_right">
      <MainTitle val="Transportation service supply" />
      <div class="supply">
        <SecTitle val="Public transport supply" :margins="'10px 0'" />
        <div class="Public_transport ul">
          <div
            class="li"
            v-for="(item, index) in PublicList"
            :key="index"
            @click="showPath(index, item)"
            :class="publicCur == item.name ? 'li_ac' : ''"
          >
            <div class="name">{{ item.name }}</div>
            <div class="info">
              <div class="value">{{ item.value }}</div>
              <!-- <div class="unit">Ind</div> -->
            </div>
            <div class="ZB">
              <div class="ZB_name" v-if="index == 0">Year on year</div>
              <div class="ZB_name" v-if="index == 1">Year on year</div>
              <div class="ZB_val">{{ item.zb }}</div>
            </div>
          </div>
        </div>
        <SecTitle val="Water bus supply" :margins="'10px 0'" />
        <div class="Water_bus ul">
          <div class="li" v-for="(item, index) in WaterList" :key="index">
            <div class="name">{{ item.name }}</div>
            <div class="info">
              <div class="value">{{ item.value }}</div>
              <!-- <div class="unit">Ind</div> -->
            </div>
            <div class="ZB">
              <div class="ZB_name" v-if="index == 0">Year on year</div>
              <div class="ZB_name" v-if="index == 1">Year on year</div>
              <div class="ZB_val">{{ item.zb }}</div>
            </div>
          </div>
        </div>
        <SecTitle val="Taxi supply" :margins="'10px 0'" />
        <div class="Taxi ul">
          <div class="li" v-for="(item, index) in TaxiList" :key="index">
            <div class="name">{{ item.name }}</div>
            <div class="info">
              <div class="value">{{ item.value }}</div>
              <!-- <div class="unit">Ind</div> -->
            </div>
            <div class="ZB">
              <div class="ZB_name" v-if="index == 0">Year on year</div>
              <div class="ZB_name" v-if="index == 1">Year on year</div>
              <div class="ZB_val">{{ item.zb }}</div>
            </div>
          </div>
        </div>
        <SecTitle val="Online car hailing supply" :margins="'10px 0'" />
        <div class="Online ul">
          <div class="li" v-for="(item, index) in OnlineList" :key="index">
            <div class="name">{{ item.name }}</div>
            <div class="info">
              <div class="value">{{ item.value }}</div>
              <!-- <div class="unit">Ind</div> -->
            </div>
            <div class="ZB">
              <div class="ZB_name" v-if="index == 0">Year on year</div>
              <div class="ZB_name" v-if="index == 1">Year on year</div>
              <div class="ZB_val">{{ item.zb }}</div>
            </div>
          </div>
        </div>
      </div>
      <MainTitle val="All in one card information statistics" :small="true">
        <div class="btnSelect">
          <div
            @click="AllInOneCardBtn('Day')"
            :class="AllInOneCardType == 'Day' ? 'select' : ''"
          >
            Day
          </div>
          <div
            @click="AllInOneCardBtn('Week')"
            :class="AllInOneCardType == 'Week' ? 'select' : ''"
          >
            Week
          </div>
          <div
            @click="AllInOneCardBtn('Month')"
            :class="AllInOneCardType == 'Month' ? 'select' : ''"
          >
            Month
          </div>
        </div>
      </MainTitle>
      <div class="AllInOneCard">
        <ChartPie
          class="chart_pie"
          width="300px"
          height="300px"
          :rowData="AllInOneCardList"
          :displayModel="displayModel"
          :color="['#A68CDB', '#17CAA6', '#73FFFF', '#56A2E7', '#1F7ED6']"
          :legends="{
            Bus: '#A68CDB',
            Taxi: '#17CAA6',
            'Rail transit': '#73FFFF',
            'Water bus': '#56A2E7',
            Other: '#1F7ED6'
          }"
          :loop_labelStyle="{
            left: '400%',
            top: '21%'
          }"
          :legendsStyle="{
            right: '-66px',
            unitright: '-90px'
          }"
        />
        <Table
          style="margin:40px 0"
          :NavData="['Category', 'Number of swipes', 'Consumption amount']"
          :TableStyle="{
            TableWidth: '680px',
            Height: '200px',
            NavlineHeight: '50px'
          }"
          :TableCountWidth="['198px', '238px', '294px']"
          :Data="ViolationsList"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ChartPie from '../components/charts/ChartPie'
import Table from '../components/common/Table'
import YibiaopanTu from '../components/charts/YibiaopanTu.vue'
import Vessel from '../components/common/Vessel.vue'
import { mapState } from 'vuex'
export default {
  name: 'Operation',
  components: {
    ChartPie,
    Table,
    YibiaopanTu,
    Vessel
  },
  data() {
    return {
      TransportType: 'Day',
      TransportList: [],
      ViolationsList2: [
        {
          first: 'Bus',
          second: '587',
          third: '487'
        },
        {
          first: 'Taxi',
          second: '896',
          third: '836'
        },
        {
          first: 'Rail transit',
          second: '1323',
          third: '966'
        },
        {
          first: 'Water bus',
          second: '78',
          third: '63'
        }
      ],
      rankingList: [
        {
          text: 'XX area',
          num: 73,
          per: 73,
          unit: 'Severe'
        },
        {
          text: 'XX area2',
          num: 87,
          per: 87,
          unit: 'Moderate'
        },
        {
          text: 'XX area3',
          num: 89,
          per: 89,
          unit: 'Moderate'
        },
        {
          text: 'XX area5',
          num: 93,
          per: 93,
          unit: 'Mild'
        },
        {
          text: 'XX area4',
          num: 98,
          per: 98,
          unit: 'Mild'
        }
      ],
      yjBg: ['#D24040', '#EAA948', '#EAA948', '#17CAA6', '#17CAA6'],
      yjColor: [
        'rgba(175,37,37,.2)',
        'rgba(158,102,18,.2)',
        'rgba(158,102,18,.2)',
        'rgba(23,202,166,.2)',
        'rgba(23,202,166,.2)'
      ],
      Traffic: [
        {
          name: 'Airport',
          value: 1
        },
        {
          name: 'Port',
          value: 4
        },
        {
          name: 'Train station',
          value: 2
        },
        {
          name: 'Bus stop',
          value: 561
        }
      ],
      PublicList: [
        {
          name: 'Line operated today',
          value: '85',
          zb: '+0.2%'
        },
        {
          name: 'Cumulative passenger capacity',
          value: '5741',
          zb: '+0.19%'
        }
      ],
      WaterList: [
        {
          name: 'Line operated today',
          value: '21',
          zb: '+0.2%'
        },
        {
          name: 'Cumulative passenger capacity',
          value: '2471',
          zb: '+0.19%'
        }
      ],
      OnlineList: [
        {
          name: 'Line operated today',
          value: '2385',
          zb: '+0.2%'
        },
        {
          name: 'Cumulative passenger capacity',
          value: '3416',
          zb: '+0.59%'
        }
      ],
      TaxiList: [
        {
          name: 'Line operated today',
          value: '2168',
          zb: '+0.56%'
        },
        {
          name: 'Cumulative passenger capacity',
          value: '3917',
          zb: '+0.59%'
        }
      ],
      AllInOneCardType: 'Day',
      AllInOneCardList: [],
      displayModel: 2,
      ViolationsList: [
        {
          first: 'Bus',
          second: 'XX times',
          third: 'USD XXX'
        },
        {
          first: 'Taxi',
          second: 'XX times',
          third: 'USD XXX'
        },
        {
          first: 'Rail transit',
          second: 'XX times',
          third: 'USD XXX'
        }
      ],
      publicCur: ''
    }
  },
  methods: {
    disRoad() {
      this.$store.commit('setHighLight', '路网消失')
    },
    AllInOneCardBtn(params) {
      this.AllInOneCardType = params
      this.getAllInOneCardList(params)
    },
    getAllInOneCardList(params) {
      this.$http.getAllInOneCardList(params).then(res => {
        this.$set(this, 'AllInOneCardList', res)
      })
    },
    TransportBtn(params) {
      this.TransportType = params
      this.getTransportList(params)
    },
    getTransportList(params) {
      this.$http.getTransportList(params).then(res => {
        this.$set(this, 'TransportList', res)
      })
    },
    // 添加公交 水巴士路径
    showPath(index, item) {
      if (this.publicCur == item.name) {
        this.publicCur = ''
        this.$store.commit('setHighLight', '无交互')
      } else {
        this.publicCur = item.name
        if (index) {
          this.$store.commit('setHighLight', '船路径')
        } else {
          this.$store.commit('setHighLight', '公交路径')
        }
      }
    }
  },
  computed: {
    ...mapState(['appInstance', 'topic'])
  },
  created() {},
  mounted() {
    this.getAllInOneCardList('Day')
    this.getTransportList('Day')
  },
  beforeDestroy() {},
  watch: {}
}
</script>

<style lang="less" scoped>
.layout_wraper {
  position: relative;
  .layout_left {
    .operation {
      height: 650px;
      .operationIndex {
        height: 225px;
        .operationIndex_Info {
          width: 680px;
          display: flex;
          justify-content: space-around;
          .left {
            width: '270px';
            height: '140px';
          }
          .right {
            width: 342px;
            height: 149px;
            background: url('../assets/img/Operation/operationIndex.png')
              no-repeat;
            .name {
              height: 38px;
              line-height: 38px;
              font-size: 28px;
              color: #26ffff;
              text-align: center;
              font-family: 'Helvetica';
            }
            .value {
              height: 85px;
              font-size: 88px;
              background: repeating-linear-gradient(to bottom, #fff, #abe1f3);
              -webkit-background-clip: text;
              color: transparent;
              text-align: center;
              font-family: 'Helvetica';
            }
            .unit {
              font-size: 20px;
              color: #bfefff;
              text-align: center;
              font-family: 'Helvetica';
            }
          }
        }
      }
      .ranking {
        .ranking_info {
          height: 295px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 0 20px;
          .right_item {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .img {
              width: 47px;
              height: 47px;
              margin-left: 36px;
            }
            .item {
              display: flex;
              align-items: center;
              width: 100%;
              // margin-bottom: 20px;
              .item_index {
                width: 64px;
                height: 27px;
                background: url('../assets/img/Operation/bt_bg.png') no-repeat;
                text-align: center;
                color: #fff;
                line-height: 27px;
                flex-shrink: 0;
              }
              .item_index3 {
                background: url('../assets/img/Operation/bt2_bg.png') no-repeat;
              }
              .item_index4 {
                background: url('../assets/img/Operation/bt2_bg.png') no-repeat;
              }
              .name {
                width: 150px;
                font-size: 28px;
                font-family: 'Helvetica';
                color: #fff;
                text-align: left;
                margin-left: 10px;
                text-shadow: 0px 0px 18px #0080ff;
              }
              .jindu {
                width: 240px;
                height: 12px;
                border-radius: 6px;
                background: rgba(255, 255, 255, 0.1);
                & > div {
                  height: 12px;
                  border-radius: 6px;
                  // background:repeating-linear-gradient() ;
                }
              }
              .value {
                font-size: 32px;
                font-family: 'Helvetica';
                color: #ffffff;
                width: 70px;
                text-align: center;
              }
              .unit {
                font-size: 28px;
                font-family: '微软雅黑';
                width: 135px;
                text-align: right;
                text-shadow: 0px 0px 18px #0080ff;
              }
            }
          }
        }
      }
    }
    .Transport {
      width: 680px;
      height: 680px;
      background: url('../assets/img/Control2/Resource_bg.png') no-repeat;
      background-position: -34px 0px;
      margin-top: 20px;
      .chart_pie {
        transform: translate(-30px, 5px);
        pointer-events: none;
      }
      /deep/.FJ_GZZDYJLB_Nav {
        background: transparent;
        height: 50px;
        li {
          text-align: left;
          text-indent: 30px;
          white-space: nowrap;
          background: rgba(77, 121, 255, 0.2);
          height: 50px;
          margin-right: 1px;
        }
      }
      /deep/.swipe_inner {
        text-align: left;
        text-indent: 30px;
        &:nth-child(odd) {
          background: transparent;
          border-bottom: 1px solid rgba(255, 255, 255, 0.15);
        }
        &:nth-child(even) {
          background: transparent;
          border-bottom: 1px solid rgba(255, 255, 255, 0.15);
        }
      }
    }
    .Traffic {
      width: 680px;
      height: 220px;
      margin-top: 20px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .li {
        width: 334px;
        height: 101px;
        // display: flex;
        // justify-content: flex-end;
        padding-left: 145px;
        box-sizing: border-box;
        .name {
          width: 222px;
          height: 38px;
          line-height: 38px;
          font-size: 28px;
          color: #fff;
          font-family: 'Helvetica';
        }
        .info {
          width: 120px;
          height: 63px;
          display: flex;
          justify-content: space-between;
          .value {
            font-size: 50px;
            font-family: 'Helvetica';
            color: #fff;
            line-height: 70px;
          }
          .unit {
            font-size: 24px;
            color: #77c5fe;
            font-family: '碳纤维正中黑简体';
            line-height: 100px;
          }
        }
        &:nth-child(1) {
          background-image: url(../assets/img/Operation/Traffic1.png);
          background-position: 25px 0;
        }
        &:nth-child(2) {
          width: 314px;
          background-image: url(../assets/img/Operation/Traffic2.png);
          background-position: 25px 0;
        }
        &:nth-child(3) {
          background-image: url(../assets/img/Operation/Traffic3.png);
          background-position: 25px 0;
        }
        &:nth-child(4) {
          width: 314px;
          background-image: url(../assets/img/Operation/Traffic4.png);
          background-position: 25px 0;
        }
      }
    }
  }
  .layout_right {
    .supply {
      height: 1000px;
      .Public_transport {
        cursor: pointer;
        .li_ac {
          position: relative;
          &::before {
            content: '';
            position: absolute;
            top: -8px;
            left: -32px;
            width: 120%;
            height: 110%;
            box-shadow: 0px 0px 12px 6px rgba(255, 201, 38, 0.65) inset;
            background-color: rgba(255, 201, 38, 0.15);
          }
        }
      }
      .ul {
        width: 680px;
        height: 180px;
        display: flex;
        justify-content: space-between;
        .li {
          width: 310px;
          height: 180px;
          background-image: url(../assets/img/Control2/Resource_bottom_bg.png);
          background-position-y: 9px;
          background-position-x: -5px;
          background-repeat: no-repeat;
          padding: 0 7px 0 10px;
          box-sizing: border-box;
          .name {
            // width: 310px;
            height: 71px;
            // line-height: 38px;
            font-size: 28px;
            color: #fff;
            font-family: 'Helvetica';
          }
          .info {
            // width: 310px;
            height: 66px;
            display: flex;
            justify-content: space-between;
            .value {
              font-size: 60px;
              font-family: 'Helvetica';
              color: #fff;
              line-height: 60px;
              background: repeating-linear-gradient(to bottom, #fff, #81bac9);
              -webkit-background-clip: text;
              color: transparent;
            }
            .unit {
              font-size: 24px;
              color: #77c5fe;
              font-family: '碳纤维正中黑简体';
              line-height: 80px;
            }
          }
          .ZB {
            display: flex;
            justify-content: space-between;
            .ZB_name {
              font-size: 20px;
              font-family: 'Helvetica';
              color: #fff;
              line-height: 33px;
            }
            .ZB_val {
              font-size: 22px;
              color: #f17163;
              font-family: 'Voltage';
              margin-right: 48px;
              line-height: 41px;
            }
          }
        }
      }
    }
    .AllInOneCard {
      width: 680px;
      height: 614px;
      background: url('../assets/img/Control2/Resource_bg.png') no-repeat;
      background-position: -34px 0px;
      margin-top: 60px;
      .chart_pie {
        transform: translate(-30px, 5px);
      }
      /deep/.FJ_GZZDYJLB_Nav {
        background: transparent;
        height: 50px;
        li {
          text-align: left;
          text-indent: 15px;
          white-space: nowrap;
          background: rgba(77, 121, 255, 0.2);
          height: 50px;
          margin-right: 1px;
        }
      }
      /deep/.swipe_inner {
        text-align: left;
        text-indent: 15px;
        &:nth-child(odd) {
          background: transparent;
          border-bottom: 1px solid rgba(255, 255, 255, 0.15);
        }
        &:nth-child(even) {
          background: transparent;
          border-bottom: 1px solid rgba(255, 255, 255, 0.15);
        }
      }
    }
  }
  .btnSelect {
    pointer-events: all;
    width: 260px;
    height: 31px;
    display: flex;
    justify-content: space-between;
    position: absolute;
    right: 0px;
    top: 80px;
    text-align: center;
    font-family: 'Helvetica';
    div {
      width: 80px;
      height: 30px;
      line-height: 30px;
      background: rgba(13, 32, 51, 0.8);
      color: #fff;
      font-size: 22px;
      cursor: pointer;
    }
    .select {
      // border-top: 1px solid #1FBBEF;
      // border-left: 1px solid #1FBBEF;
      background-image: url(../assets/img/Control2/select_btn.png);
    }
  }
}
</style>
